/* import __COLOCATED_TEMPLATE__ from './delete-group-modal.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent-2 */

import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type PlaygroundApiService from 'embercom/services/playground-api';

interface DeleteGroupModalArgs {
  onClose: () => void;
  groupId: number;
}

export default class DeleteGroupModal extends Component<DeleteGroupModalArgs> {
  @service declare router: RouterService;
  @service declare appService: $TSFixMe;
  @service declare playgroundApi: PlaygroundApiService;
  @service declare intercomEventService: $TSFixMe;
  get routeToTransitionTo() {
    return this.appService.app.canUseStandalone
      ? 'apps.app.standalone.testing.index'
      : 'apps.app.automation.fin-ai-agent.testing.index';
  }

  @action deleteGroup(groupId: number) {
    this.playgroundApi.deletePlaygroundGroup(groupId);

    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: 'confirm_delete_group_button',
      context: 'playground',
    });

    this.router.transitionTo(this.routeToTransitionTo);
    this.args.onClose();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Playground::Modals::DeleteGroupModal': typeof DeleteGroupModal;
  }
}
